<template>
  <div class="asc-error-type-label">
    <asc-label size="sm" :value="value"></asc-label>
  </div>
</template>

<script>
import AscLabel from './AscLabel'

export default {
  name: 'AscErrorTypeLabel',

  components: {
    AscLabel,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
  },
}
</script>
